module.exports = __webpack_public_path__ + "static/img/pin-trap-scheduled-irregular.e7f83d7.svg";